import { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell as MuiTableCell,
  TableBody,
  Paper,
  styled,
  Grid,
} from "@mui/material";
import { toast } from "react-toastify";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import publicationsData from "../../utils/ResearchPaperPublication.json";

type Props = {};

type Publication = {
  srNo: number;
  issnNo: string;
  publicationType: string;
  publicationTitle: string;
  authors: string;
  journalName: string;
  publicationYear: number;
};

const YearList = [
   {
    year: "2025",
    subtabs: [],
  },
  {
    year: "2024",
    subtabs: [],
  },

  {
    year: "2023",
    subtabs: [],
  },

  {
    year: "2022",
    subtabs: [],
  },

  {
    year: "2021",
    subtabs: [],
  },

  {
    year: "2020",
    subtabs: [],
  },
];

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 14,
  textAlign: "left",
  color: theme.palette.primary.contrastText,
}));

function ResearchPaperPublication({}: Props) {
  const [selectedYear, setSelectedYear] = useState<string | null>(null);

  const handleYearClick = (year: string) => {
    if (selectedYear === year) {
      setSelectedYear(null);
    } else {
      setSelectedYear(year);
    }
  };

  useEffect(() => {
    publicationsData.filter(
      (item) => item.publicationYear.toString() === selectedYear?.toString()
    )?.length < 1 &&
      selectedYear &&
      toast("No Data Found", {});
  }, [selectedYear]);

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90vw",
      }}
      m={2}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        <Grid container spacing={2}>
          {YearList?.map((item, idx) => (
            <Grid item key={idx}>
              <Box sx={{ width: "100%" }}>
                <Grid container alignItems={"center"}>
                  <Grid
                    sx={{
                      fontSize: 24,
                      transform: `rotate(${
                        item.year === selectedYear ? 90 : 0
                      }deg)`,
                    }}
                  >
                    <ArrowForwardIosIcon />
                  </Grid>
                  <Grid>
                    <Typography
                      onClick={() => handleYearClick(item.year)}
                      sx={{
                        display: "block",
                        cursor: "pointer",
                        textDecoration: "none",
                        fontWeight: "bold",
                        fontSize: 16,
                        "&:hover": {
                          textDecoration: "underline",
                          color: "primary.main",
                        },
                        ml: 1,
                      }}
                    >
                      {item.year}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ))}
        </Grid>
        {publicationsData?.filter(
          (item) =>
            item?.publicationYear.toString() === selectedYear?.toString()
        )?.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 4 }}>
            <Typography
              variant="h6"
              sx={{ p: 2, backgroundColor: "primary.main", color: "white" }}
            >
              Year : {`${selectedYear}`}
            </Typography>
            <Table>
                <TableHead>
                <TableRow>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Sr. No</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">ISSN No</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Publication Type</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Publication Title</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Author/s</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Journal Name</Typography>
                  </TableCell>
                  <TableCell align="center">
                  <Typography fontWeight="bold">Year</Typography>
                  </TableCell>
                </TableRow>
                </TableHead>
              <TableBody>
                {publicationsData
                  .filter(
                    (item) =>
                      item.publicationYear.toString() ===
                      selectedYear?.toString()
                  )
                  .map((publication) => (
                    <TableRow key={publication.srNo}>
                      <TableCell align="center">{publication.srNo}</TableCell>
                      <TableCell align="center">{publication.issnNo}</TableCell>
                      <TableCell align="center">
                        {publication.publicationType}
                      </TableCell>
                      <TableCell align="center">
                        {publication.publicationTitle}
                      </TableCell>
                      <TableCell align="center">
                        {publication.authors}
                      </TableCell>
                      <TableCell align="center">
                        {publication.journalName}
                      </TableCell>
                      <TableCell align="center">
                        {publication.publicationYear}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Stack>
    </Box>
  );
}

export default ResearchPaperPublication;
